import animations from 'Assets/js/modules/animations';
import jsUtils from '@pernod-ricard-global-cms/jsutils';

export default function stickynav(options = {}) {
  try {
    const { block } = options;
    jsUtils.loadCss(block.dataset.assetkey, options).then(() => {
      animations.fadeIn(block);

      const $stickynav = document.querySelector('.stickynav');
      const openClose = () => {
        $stickynav.classList.toggle('stickynav--is-open');
        $stickynav.classList.toggle('stickynav--is-closed');
      };

      // toggle buttons
      const $button = $stickynav.querySelector('.stickynav__button');
      if ($button !== null) {
        $button.addEventListener('click', () => {
          openClose();
        });
      }

      // it gets the text when clicking on one of the options and swap text
      const $items = document.querySelectorAll('.stickynav ul > li');
      const $label = document.querySelector('.stickynav__label');
      const stickyFocus = 'stickynav--focus';
      const removeHighlight = (items) => {
        items.forEach(($li) => {
          $li.classList.remove(stickyFocus);
        });
      };

      if ($items !== null) {
        $items.forEach(($li) => {
          $li.addEventListener('click', (item) => {
            openClose();
            removeHighlight($items);
            if (item.target !== null) {
              // swap label text
              $label.textContent = item.target.textContent;
              // highlight link (desktop)
              item.target.parentNode.classList.add(stickyFocus);
            }
          });
        });
      }
    });
  } catch (error) {
    console.error(error);
  }
}
